import moment from "moment";

module.exports = {
    className: "MobilePOSScanLog",
    classNameLabel: "Mobile POS Scan Log",
    limit: 10,
    showCreate: false,
    showUpdate: false,
    showDelete: false,
    showExport: false,
    columns: [
        {
            columnName: "objectId",
            type: "string"
        },
        {
            columnName: "memberId",
            columnLabel: "member Id",
            type: "string",
        },
        {
            columnName: "qrCodeTimestamp",
            columnLabel: "QR Code Timestamp",
            type: "Date",
            format: "MMM DD, YYYY hh:mm:ss A"
        },
        {
            columnName: "documentNo",
            columnLabel: "document No",
            type: "string",
        },
        {
            columnName: "date",
            type: "date",
            render: ({ object }) => {
                return moment(object.get("createdAt")).format("MMM DD, YYYY hh:mm:ss A")
            }
        },
        {
            columnName: "createdAt",
            type: "Date"
        },
        {
            columnName: "updatedAt",
            type: "Date"
        }
    ]
}  


// WEBPACK FOOTER //
// ./components/MobilePOSScanLog/MobilePOSScanLog.js